<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline :title="isEdit ? 'Edit Service Enquiry' : 'Add Service Enquiry'">
        <v-card-actions>
          <span @click="$router.back()">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
          </span>
        </v-card-actions>
        <div v-if="enquiryCode">

          <v-card-actions>
            <v-subheader><span class="font-weight-medium">Enquiry Code :</span><span class="font-weight-bold">{{
              enquiryCode }}</span>
            </v-subheader>
            <v-row class="align-center" justify="end">
              <router-link class="px-2 ml-1 ma-1"
                :to="{ name: 'listAssignedServices', params: { enquiryID: enquiryID, franchiseeID: franchiseeID, academicYearID: academicYearID } }"
                title="Assigned Service Plan">
                <v-btn small class="px-2 ml-1 ma-1" outlined>View Assigned Service</v-btn>
              </router-link>

              <router-link
                :to="{ name: 'assignServicePlan', params: { enquiryID: enquiryID, franchiseeID: franchiseeID, academicYearID: academicYearID } }"
                v-if="franchiseeID">
                <v-btn small class="px-2 ml-1 ma-1" color="darkblue" outlined>Assign Service</v-btn>
              </router-link>
            </v-row>

          </v-card-actions>

        </div>
        <v-card flat class="px-2" v-if="!enquiryCode">
          <form autocomplete="off" @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Academic Year
                </label>
                <v-autocomplete class="my-0 py-1" clearable v-model.trim="academicYearID" :items="academicYears" key="id"
                  item-value="id" item-text="academicYear">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Franchisee
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete class="my-0 py-1" required placeholder="Select Franchisee" clearable
                  v-model.trim="franchiseeID" :items="franchiseeList" key="id" item-value="id" item-text="companyName">
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Date of Enquiry
                  <span class="requir error--text">*</span>
                </label>
                <custom-date-picker disabled class="my-0 py-1" v-model.trim="doe" />
              </v-col>

              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Student Name
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" :disabled="isEdit" counter="100" pattern="[a-zA-Z\s]+"
                  placeholder="Student Name" required v-model.trim="name" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Class
                </label>
                <v-autocomplete class="my-0 py-1" :items="classes" item-value="id" item-text="name"
                  placeholder="Select Class" v-model.trim="classId" key="id"> </v-autocomplete>
              </v-col>

              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Parent's Name
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field required :disabled="isEdit" class="my-0 py-1" counter="100" pattern="[a-zA-Z\s]+"
                  placeholder="Parent's Name" v-model.trim="fatherName" maxlength="100"></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Parent's Mobile
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field :disabled="isEdit" type="number" class="my-0 py-1" placeholder="Parent's Mobile" required
                  v-model.trim="fatherMobile" onKeyPress="if(this.value.length==10) return false;"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Parent's email
                  <span class="requir error--text">*</span>
                </label>
                <v-text-field required :disabled="isEdit" type="email" class="my-0 py-1" counter="100"
                  placeholder="Parent's email" v-model.trim="fatherEmailID" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">

                  <!-- <router-link
                    :to="{ name: 'EditEnquiries', params: { enquiryCode: this.enquiryCode, radio: 'all' } }"> -->
                  <v-btn bottom right elevation="1" color="primary" type="submit" :disabled="hasClicked">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card flat class="px-2" v-else>
          <form autocomplete="off" @submit.prevent="editSave">
            <v-row>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Academic Year
                </label>
                <v-autocomplete class="my-0 py-1" clearable v-model.trim="academicYearID" :items="academicYears" key="id"
                  item-value="id" item-text="academicYear">
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Franchisee
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete class="my-0 py-1" required placeholder="Select Franchisee" clearable
                  v-model.trim="franchiseeID" :items="franchiseeList" key="id" item-value="id" item-text="companyName">
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Date of Enquiry
                  <span v-if="!isEdit" class="requir error--text">*</span>
                </label>
                <custom-date-picker disabled class="my-0 py-1" v-model.trim="doe" />
              </v-col>

              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Student Name
                </label>
                <v-text-field class="my-0 py-1" :disabled="isEdit" counter="100" pattern="[a-zA-Z\s]+"
                  placeholder="Student Name" required v-model.trim="name" maxlength="100"></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Class
                </label>
                <v-autocomplete class="my-0 py-1" :items="classes" item-value="id" item-text="name"
                  placeholder="Select Class" v-model.trim="classId" key="id"> </v-autocomplete>
              </v-col>

              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Parent's Name
                </label>
                <v-text-field required :disabled="isEdit" class="my-0 py-1" counter="100" pattern="[a-zA-Z\s]+"
                  placeholder="Parent's Name" v-model.trim="fatherName" maxlength="100"></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Parent's Mobile
                </label>
                <v-text-field :disabled="isEdit" type="number" class="my-0 py-1" placeholder="Parent's Mobile" required
                  v-model.trim="fatherMobile" onKeyPress="if(this.value.length==10) return false;"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">
                  Parent's email
                </label>
                <v-text-field required :disabled="isEdit" type="email" class="my-0 py-1" counter="100"
                  placeholder="Parent's email" v-model.trim="fatherEmailID" maxlength="100"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" color="primary" type="submit" :disabled="hasClicked">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import CONSTANTS from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
// import _ from 'lodash'
export default {
  name: 'serviceEnquiry',
  props: ['enquiryCodeProp', 'newMobileProp', 'radio2'],
  components: {
    MaterialCard,
    CustomDatePicker
  },
  data () {
    return {
      enquiryCode: null,
      stateList: [],
      title: 'Add Service Enquiry',
      academicYears: [],
      classes: [],
      classId: '',
      academicYearID: '',
      franchiseeID: '',
      franchiseeList: [],
      doe: moment().format('YYYY-MM-DD'),
      maxToDate: moment().format('YYYY-MM-DD'),
      name: '',
      dob: '',
      gender: '',
      fatherName: '',
      fatherMobile: '',
      fatherEmailID: '',
      motherName: '',
      motherMobile: '',
      motherEmailID: '',
      address: '',
      pincode: '',
      state: '',
      hasClicked: false,
      isLoading: false,
      inProgress: false,
      isEdit: false,
      enquiryID: '',
      radio: 'all',
      genderArray: [
        { text: 'Girl', value: 'FEMALE' },
        { text: 'Boy', value: 'MALE' }
      ],
      // pocArray: [
      //   { text: 'Mother', value: 'Mother' },
      //   { text: 'Father', value: 'Father' }
      // ],
      isServiceClasses: false
    }
  },
  created: async function () {
    if (this.newMobileProp) {
      this.fatherMobile = this.newMobileProp
    }
    await this.getClassList()
    if (this.enquiryCodeProp) {
      this.isEdit = true
      await this.getStudentDataByMobile()
    }
    if (this.radio2) {
      this.radio = this.radio2
    }
  },
  computed: {
    ...mapGetters({
      academicYear: 'getAcademicYear',
      franchisee: 'getFranchisee'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    academicYear: async function () {
      await this.onFranchiseeChange()
    },
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  methods: {
    getStudentDataByMobile: async function () {
      try {
        let data = await http.get(`${CONSTANTS.API_URL}/api/service/enquiry/${this.enquiryCodeProp}`)
        let student = data.data
        this.name = student.studentFirstName
        this.franchiseeID = student.serviceRegistration?.franchisee?.id || student?.franchisee?.id || ''
        this.doe = student.dateOfEnquiry ? moment(student.dateOfEnquiry).format('YYYY-MM-DD') : ''
        this.dob = student.dateOfBirth ? moment(student.dateOfBirth).format('YYYY-MM-DD') : ''
        this.gender = student.gender
        this.classId = student.serviceRegistration?.studentClass?.id || student.classID
        this.fatherName = student.fatherName
        this.fatherMobile = student.fatherMobile
        this.fatherEmailID = student.fatherEmailID
        this.motherName = student.motherName
        this.motherMobile = student.motherMobile
        this.motherEmailID = student.motherEmailID
        this.address = student.address1
        this.pincode = student.pincode
        this.state = student.state
        this.poc = student.pointOfContact
        this.enquiryCode = student.enquiryCode
        this.enquiryID = student.id
        console.log(this.radio, 'Radio' + this.enquiryCode, 'Enquiry' + this.enquiryID)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log(e)
        this.errMsg(`Error ${errorMessage}`)
      } finally {
      }
    },
    // getRegService: async function () {
    //   try {
    //     let data = await http.get(`${CONSTANTS.API_URL}/api/service/registration`)
    //     let student = data.data

    //     this.enquiryCode = student.enquiryCode
    //     this.enquiryID = student.id
    //     console.log(this.radio, 'Radio' + this.enquiryCode, 'Enquiry' + this.enquiryID)
    //   } catch (e) {
    //     const errorMessage = (e && e.response && e.response.data.message) || e.message
    //     this.errMsg(`Error ${errorMessage}`)
    //   } finally {
    //   }
    // },
    // number: function () {
    //   let reg = /^[6-9]\d{9}$/
    //   let result = this.motherMobile.match(reg)
    //   if (result) {
    //     return true
    //   } else {
    //     this.errMsg('Not a valid number')
    //     return false
    //   }
    // },

    save: async function () {
      if (this.fatherMobile) {
        let reg = /^[6-9]\d{9}$/
        if (!this.fatherMobile.match(reg)) {
          this.errMsg('Please enter correct number!!')
          return false
        }
      }
      this.hasClicked = true
      this.isLoading = true
      try {
        let formData = {
          classID: this.classId || null,
          dateOfEnquiry: this.doe,
          studentName: this.name,
          dateOfBirth: this.dob,
          gender: this.gender,
          fatherName: this.fatherName,
          fatherMobile: this.fatherMobile,
          fatherEmailID: this.fatherEmailID,
          motherName: this.motherName,
          motherMobile: this.motherMobile,
          motherEmailID: this.motherEmailID,
          address1: this.address,
          pincode: this.pincode,
          state: this.state,
          academicYearID: this.academicYearID,
          franchiseeID: this.franchiseeID
        }
        let res = await http.post(`${CONSTANTS.API_URL}/api/service/registration`, formData)
        this.enquiryCode = res.data.enquiry.enquiryCode

        this.okMsg('Enquiry added successfully!')
        this.$router.push({
          name: 'followupDetails',
          params: {
            enquiryCode: this.enquiryCode,
            type: 'Service'
          }
        })
      } catch (e) {
        this.hasClicked = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    editSave: async function () {
      this.hasClicked = true
      this.isLoading = true
      try {
        let formData = {
          classID: this.classId || null,
          dateOfEnquiry: this.doe,
          studentName: this.name,
          dateOfBirth: this.dob,
          gender: this.gender,
          fatherName: this.fatherName,
          fatherMobile: this.fatherMobile,
          fatherEmailID: this.fatherEmailID,
          motherName: this.motherName,
          motherMobile: this.motherMobile,
          motherEmailID: this.motherEmailID,
          address1: this.address,
          pincode: this.pincode,
          state: this.state,
          // pointOfContact: this.poc,
          academicYearID: this.academicYearID,
          franchiseeID: this.franchiseeID
          // centreFranchiseeID: this.centreFranchiseeID || null
        }

        await http.put(`${CONSTANTS.API_URL}/api/service/registration/${this.enquiryID}`, formData)
        this.okMsg('Enquiry Updated successfully!')
        this.$router.push({ name: 'serviceEnquiries' })
        // this.$router.push({ name: 'spancoList' })
      } catch (e) {
        this.hasClicked = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error ${errorMessage}`)
      } finally {
        this.isLoading = false
      }
    },
    getYearList: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${CONSTANTS.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = response.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/student/service/class/category?isRequired=true`)
        if (res) {
          this.classes = res.data
          console.log('classes605::', this.classes)
          this.classes.forEach((item) => {
            console.log('clases.category607::::', item.category)
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getFranchisee: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${CONSTANTS.API_URL}/api/franchisee/active`)
        this.franchiseeList = res.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getState: async function () {
      try {
        this.isLoading = true
        const stateresponse = await http.get(`${CONSTANTS.API_URL}/api/states`)
        this.stateList = stateresponse.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        await this.getYearList()
        await this.getFranchisee()
        await this.getState()
        this.inProgress = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
